module.exports = __webpack_public_path__ + "static/media/archived-focused.1ec32fac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/archived-focused.svg
// module id = 1232
// module chunks = 0